export default {
  component: () => import('./page.vue'),
  path: '/lite-family',
  name: 'lite-family',
  meta: {
    title: '家人健康',
    auth: true,
  },
};
